(function ($) {
  // prettier-ignore
  const sites = {
    com: {
      match_urls: ['https://huntbikewheels.com'],
      url: 'https://huntbikewheels.com',
      locations: ['GB', 'IM', 'JE', 'GG'],
    },
    cc: {
      match_urls: [
        'https://huntbikewheels.cc',
        'https://huntbikewheels-dev.myshopify.com',
      ],
      url: 'https://huntbikewheels.cc',
      locations: [
        // prettier-ignore
        'ZW', 'ZM', 'YE', 'EH', 'WF', 'VI', 'VG', 'VN', 'VE', 'VU', 'UZ', 'UY',
        'UM', 'AE', 'UA', 'UG', 'TV', 'TC', 'TM', 'TR', 'TN', 'TT', 'TO', 'TK',
        'TG', 'TL', 'TH', 'TZ', 'TJ', 'TW', 'SY', 'CH', 'SZ', 'SJ', 'SR', 'SD',
        'LK', 'SS', 'GS', 'ZA', 'SO', 'SB', 'SX', 'SG', 'SL', 'SC', 'RS', 'SN',
        'SA', 'ST', 'SM', 'WS', 'VC', 'PM', 'MF', 'LC', 'KN', 'SH', 'BL', 'RW',
        'RU', 'RE', 'QA', 'PR', 'PN', 'PH', 'PE', 'PY', 'PG', 'PA', 'PS', 'PW',
        'PK', 'OM', 'NO', 'MP', 'NF', 'NU', 'NG', 'NE', 'NI', 'NZ', 'NC', 'NP',
        'NR', 'NA', 'MM', 'MZ', 'MA', 'MS', 'ME', 'MN', 'MC', 'MD', 'FM', 'MX',
        'YT', 'MU', 'MR', 'MQ', 'MH', 'ML', 'MV', 'MY', 'MW', 'MG', 'MK', 'MO',
        'LI', 'LY', 'LR', 'LS', 'LB', 'LA', 'KG', 'KW', 'KR', 'KP', 'KI', 'KE',
        'KZ', 'JO', 'JP', 'JM', 'IL', 'IQ', 'IR', 'ID', 'IN', 'IS', 'HK', 'HN',
        'VA', 'HM', 'HT', 'GY', 'GW', 'GN', 'GT', 'GU', 'GP', 'GD', 'GL', 'GI',
        'GH', 'GE', 'GM', 'GA', 'TF', 'PF', 'GF', 'FJ', 'FO', 'FK', 'ET', 'ER',
        'GQ', 'SV', 'EG', 'EC', 'DO', 'DM', 'DJ', 'CW', 'CU', 'CI', 'CR', 'CK',
        'CD', 'CG', 'KM', 'CO', 'CC', 'CX', 'CN', 'CL', 'TD', 'CF', 'KY', 'CV',
        'CA', 'CM', 'KH', 'BI', 'BF', 'BN', 'IO', 'BR', 'BV', 'BW', 'BA', 'BQ',
        'BO', 'BT', 'BM', 'BJ', 'BZ', 'BY', 'BB', 'BD', 'BH', 'BS', 'AZ', 'AU',
        'AW', 'AM', 'AR', 'AG', 'AQ', 'AI', 'AO', 'AD', 'AS', 'DZ', 'AL', 'AX',
        'AF',
      ],
      multicurrency: ['CA', 'NZ', 'NO', 'SG', 'CH'],
    },
    us: {
      match_urls: ['https://us.huntbikewheels.com'],
      url: 'https://us.huntbikewheels.com',
      locations: ['US'],
    },
    eu: {
      match_urls: ['https://eu.huntbikewheels.com'],
      url: 'https://eu.huntbikewheels.com',
      locations: [
        'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
        'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
        'SI', 'ES', 'SE',
      ],
    },
  };

  $(document).ready(() => {
    const $redirectOverlay = document.querySelector('#trf-redirect-overlay');
    const $customerOrigin = document.querySelector('#trf-redirect-customer-origin');
    const $yesBtn = document.querySelector('#trf-redirect-yes');
    const $closeBtn = document.querySelector('#trf-redirect-close');
    const $chooseRegionBtn = document.querySelector('#trf-redirect-choose-region');
    const $regionsList = document.querySelector('#trf-redirect-regions');
    const $shippingNotice = document.querySelectorAll('.shipping-location-notice');
    const $locationSelects = document.querySelectorAll('.trf-location-select');
    const currentUrl = new URL(window.location);

    // We need to keep the query params when opening the other site domains.
    // We cannot do it (easily) in liquid, see https://community.shopify.dev/t/get-query-params-in-liquid/1593/4
    $regionsList.querySelectorAll('a').forEach((el) => {
      // assuming the `el` does not have a query param and believing that `URL.search` always has a leading `?`
      el.href += currentUrl.search;
    });

    const redirect = (redirectUrl) => window.location.replace(redirectUrl + location.pathname);
    const getLocation = () => {
      return $.ajax({
        url: 'https://api.ipstack.com/check?access_key=6029f0b576ca2c2d70330c48018cedff',
        dataType: 'json',
      }).then((locationData) => {
        sessionStorage.setItem('location_data', JSON.stringify(locationData));

        const suitableSiteKey = Object.keys(sites).find((key) =>
          sites[key].locations.includes(locationData.country_code)
        );

        // no suitable site to redirect found
        if (!suitableSiteKey || !sites[suitableSiteKey]) return {};

        return { suitableSiteKey, locationData };
      });
    };

    getLocation()
      .then(({ suitableSiteKey, locationData }) => {
        if (!suitableSiteKey) return { suitableSiteKey, locationData };

        const currentSiteUrl = window.location.origin.replace('www.', '');
        // prettier-ignore
        const isCorrectSite = sites[suitableSiteKey].match_urls.includes(currentSiteUrl);
        // the suitable site is already the currently opened site
        if (!isCorrectSite) {
          if (TRF.CONFIG.SHIPPING_NOTICE_TEXT && $shippingNotice) {
            const countryName = locationData.country_name;
            const siteUrl = sites[suitableSiteKey].url;
            const shippingNotice = TRF.CONFIG.SHIPPING_NOTICE_TEXT.replace(
              '{country}',
              `<span class="country">${countryName}</span>`
            ).replace('{site}', `<span class="site"><a href="${siteUrl}">${siteUrl}</a></span>`);

            $shippingNotice.forEach(($el) => {
              $el.classList.remove('hide');
              $el.innerHTML = shippingNotice;
            });
          }

          const locationPopup = !!sessionStorage.getItem('locationPopup');

          // location popup has already been shown
          if (locationPopup) return;

          $customerOrigin.textContent = locationData.country_name;
          // assuming the `sites[suitableSiteKey].url` does not have a query param and believing that `URL.search` always has a leading `?`
          $yesBtn.dataset.redirect = sites[suitableSiteKey].url + currentUrl.search;
          $redirectOverlay.classList.add('show');
        }

        return { suitableSiteKey, locationData };
      })
      .fail((err) => {});

    $regionsList.querySelectorAll('li .close-popup').forEach(($el) => {
      $el.addEventListener('click', (event) => {
        sessionStorage.setItem('locationPopup', true);

        if ($el.dataset.currencyCountryCode && $locationSelects.length) {
          $locationSelects.forEach(($locationSelect) => {
            const options = [...$locationSelect.options].map(($opt) => $opt.value);

            if (options.includes($el.dataset.currencyCountryCode)) {
              if ($locationSelect.value === $el.dataset.currencyCountryCode) {
                $redirectOverlay.classList.remove('show');
              } else {
                $locationSelect.value = $el.dataset.currencyCountryCode;
                $locationSelect.form.submit();
              }
            }
          });
        } else {
          $redirectOverlay.classList.remove('show');
        }
      });
    });

    $yesBtn.addEventListener('click', () => {
      sessionStorage.setItem('locationPopup', true);
      redirect($yesBtn.dataset.redirect);
    });

    $closeBtn.addEventListener('click', () => {
      $redirectOverlay.classList.remove('show');
    });

    $chooseRegionBtn.addEventListener('click', (e) => {
      $regionsList.classList.toggle('hide');
    });

    $closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      sessionStorage.setItem('locationPopup', true);
      $redirectOverlay.classList.remove('show');
    });

    $locationSelects.forEach(($select) => {
      $select.addEventListener('change', (event) => {
        const returnToElement = event.target.form.querySelector('[name="return_to"]');
        returnToElement.value = window.location.pathname + window.location.search;
        event.target.form.submit();
      });
    });
  });
})($);
